// extracted by mini-css-extract-plugin
export default {"wrapper":"ChartWrapper_wrapper__aDdmQ"};